import React from 'react';

import TaskAssignmentPopupContent from '../../task/pills/assignment/TaskAssignmentPopupContent';
import ToggleChip from '../behaviours/ToggleChip';
import AssignmentChipView, { type RenderAssignmentPopupContent } from './AssignmentChipView';
import type { ElementAssignmentChipDescriptor } from '../elementChipsTypes';
import { ChipBaseProps } from '../../../../common/@roma/src/components/base/chip/ChipBase';

type AssignmentChipProps = {
    chip: ElementAssignmentChipDescriptor;
    size: ChipBaseProps['size'];
    canModify: boolean;
    /** Removes all assignments from the owning container. */
    onRemove: () => void;
    /** Renders the assignee picker shown in the chip's selection-owned popup. Defaults to the element-id popup. */
    renderPopupContent?: RenderAssignmentPopupContent;
};

/**
 * Renders a task assignment pill and its generic selection-owned picker view.
 */
const AssignmentChip: React.FC<AssignmentChipProps> = ({ chip, size, canModify, onRemove, renderPopupContent }) => {
    const { containerId, assigneeId, assigneeName, isSearchHighlighted } = chip;
    const popupId = `task-assignment-${containerId}-${assigneeId}`;

    const renderContent: RenderAssignmentPopupContent =
        renderPopupContent ?? (() => <TaskAssignmentPopupContent popupId={popupId} elementId={containerId} />);

    return (
        <ToggleChip chip={chip} canModify={canModify} onDelete={onRemove}>
            {({ isSelected, canActivate, deselect, chipRef, chipProps }) => (
                <AssignmentChipView
                    chipRef={chipRef}
                    chipProps={chipProps}
                    size={size}
                    variant="user"
                    containerId={containerId}
                    isSelected={isSelected}
                    isDisabled={!canActivate}
                    isSearchHighlighted={isSearchHighlighted}
                    deselect={deselect}
                    renderPopupContent={renderContent}
                >
                    @{assigneeName}
                </AssignmentChipView>
            )}
        </ToggleChip>
    );
};

export default AssignmentChip;
